import React from 'react';
import { Wrapper, Container, Image } from './styled';

const Section = ({ children, bgImage, header, id, typeImage = 'bg', image, bgColor = null }) => {
    return (
        <Wrapper header={header} id={id} bgColor={bgColor}>
            {bgImage && typeImage === 'bg' && bgImage}
            <Container>
                {children}
                {typeImage === 'image' && image && <Image src={image}/>}
            </Container>
        </Wrapper>
    );
};

export default Section;
